import { render, staticRenderFns } from "./ItemHeader.vue?vue&type=template&id=8b0da59e&scoped=true&"
import script from "./ItemHeader.vue?vue&type=script&lang=js&"
export * from "./ItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./ItemHeader.vue?vue&type=style&index=0&id=8b0da59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0da59e",
  null
  
)

export default component.exports